<template>
  <section class="empty-state-container">
    <div class="empty-state-card">
      <div class="illustration-wrapper">
        <img
          src="@/assets/img/employee-empty-illustration.svg"
          alt="No employees"
          class="illustration"
        />
      </div>
      <template
        v-if="
          !employeeInvite || (employeeInvite && employeeInvite.length === 0)
        "
      >
        <h2 class="empty-title">
          No Employees Invited Yet
        </h2>
        <p class="empty-description">
          You are one step away from creating happiness for your employees!
        </p>
        <router-link
          :to="{ name: 'InviteEmployee' }"
          class="action-link"
        >
          <CustomButton title="Invite Employee" />
        </router-link>
      </template>
      <template v-else>
        <h2 class="empty-title">
          View Your Employee Invites
        </h2>
        <p class="empty-description">
          Check the status of pending invitations and manage employee equity.
        </p>
        <router-link
          :to="{ name: 'Employees' }"
          class="action-link"
        >
          <CustomButton title="View Invites" />
        </router-link>
      </template>
    </div>
  </section>
</template>

<script>
  import CustomButton from "@/components/general/BtnComponent";
  import { mapGetters } from "vuex";
  export default {
    name: "EmployeesEmptyState",
    components: {
      CustomButton,
    },
    computed: {
      ...mapGetters("Esop", ["employeeInvite"]),
    },
  };
</script>

<style lang="scss" scoped>
  .empty-state-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
  }

  .empty-state-card {
    text-align: center;
    max-width: 400px;
  }

  .illustration-wrapper {
    margin-bottom: 24px;
  }

  .illustration {
    max-width: 200px;
    height: auto;
    opacity: 0.9;
  }

  .empty-title {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 10px 0;
  }

  .empty-description {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #64748B;
    margin: 0 0 24px 0;
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
  }

  .action-link {
    display: inline-block;
  }
</style>
